export const CURRENCIES = {
	USD: "$"
};

export const PAYMENT_PROCESSORS = {
	PAYPAL: "paypal",
	STRIPE: "stripe"
};